'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Simple panel layout with left panel and right content sub directives.
 *
 * Can be used as a simplePage or inside a tabsetPage.
 */
ngModule.directive("tlPanelLayout", function () {
  var PANEL_OPENED_CLASS = "panel-opened",
    PANEL_CLOSED_CLASS = "panel-closed",
    PANEL_ANIMATING_CLASS = "panel-animating",
    PANEL_HIDDEN_CLASS = "panel-invisible";
  return {
    restrict: "E",
    replace: true,
    require: ["tlPanelLayout", "?^tlTabsetContent"],
    scope: true,
    transclude: true,
    template: '<div class="tl-panel-container" ng-transclude></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        tabContentCtrl = controllers[1];
      var opened = _.has($attrs, "panelOpened") && $attrs.panelOpened !== "false" ? true : false;
      ctrl.setPanelInitialState(opened);
      if (tabContentCtrl) {
        tabContentCtrl.usePanelLayout(true);
        ctrl.$setTabCtrl(tabContentCtrl);
      }
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        tabCtrl = null,
        animating = false,
        panelOpened = true;
      var notifyResize = function notifyResize() {
        $scope.$parent.$broadcast("$resize");
      };
      ctrl.$setTabCtrl = function (_tabCtrl) {
        tabCtrl = _tabCtrl;
        tabCtrl.setPanelOpened(panelOpened);
      };
      ctrl.setPanelInitialState = function (opened) {
        panelOpened = opened;
        $element.addClass(panelOpened ? PANEL_OPENED_CLASS : PANEL_CLOSED_CLASS).removeClass(panelOpened ? PANEL_CLOSED_CLASS : PANEL_OPENED_CLASS);
      };
      ctrl.togglePanel = function () {
        if (animating) {
          return;
        }
        animating = true;
        $element.addClass(PANEL_ANIMATING_CLASS);
        var leftPanel = $element.find(".tl-panel-left"),
          rightPanel = $element.find(".tl-panel-right");
        var onAnimationEnd = function onAnimationEnd() {
          $scope.$apply(function () {
            panelOpened = !panelOpened;
            animating = false;
            leftPanel.css({
              left: ""
            });
            rightPanel.css({
              left: ""
            });
            $element.removeClass(PANEL_ANIMATING_CLASS).addClass(panelOpened ? PANEL_OPENED_CLASS : PANEL_CLOSED_CLASS).removeClass(panelOpened ? PANEL_CLOSED_CLASS : PANEL_OPENED_CLASS);
            tabCtrl && tabCtrl.setPanelOpened(panelOpened);
            notifyResize();
          });
        };
        if (panelOpened) {
          $.when(leftPanel.animate({
            left: "-270px"
          }), rightPanel.animate({
            left: "0px"
          })).then(onAnimationEnd);
        } else {
          $.when(leftPanel.animate({
            left: "0px"
          }), rightPanel.animate({
            left: "270px"
          })).then(onAnimationEnd);
        }
      };

      /**
       * retire ou remet le panel de gauche (et le handler).
       * @param visible
       */
      ctrl.panelVisible = function (visible) {
        if (!visible) {
          console.log('==> - panelLayout::hidePanel');
          var panelLeft = $element.find(".tl-panel-left");
          var panelRight = $element.find(".tl-panel-right");
          var find = panelLeft.find(".tl-panel-handle");
          find.addClass(PANEL_HIDDEN_CLASS);
          panelLeft.addClass(PANEL_HIDDEN_CLASS);
          panelRight.addClass(PANEL_HIDDEN_CLASS);
        } else {
          console.log('==> - panelLayout::showPanel');
          var _panelLeft = $element.find(".tl-panel-left");
          var _panelRight = $element.find(".tl-panel-right");
          var _find = _panelLeft.find(".tl-panel-handle");
          _find.removeClass(PANEL_HIDDEN_CLASS);
          _panelLeft.removeClass(PANEL_HIDDEN_CLASS);
          _panelRight.removeClass(PANEL_HIDDEN_CLASS);
        }
      };
    }
  };
});

/**
 * The left side ( panel ) of the layout
 */
ngModule.directive("tlPanelLeft", function () {
  return {
    restrict: "E",
    require: "^tlPanelLayout",
    replace: true,
    scope: true,
    transclude: true,
    template: '' + '<div class="tl-panel-left">' + '   <div class="tl-panel-content tl-panel-form" ng-transclude></div>' + '   <div class="tl-panel-handle" ng-click="togglePanel()"></div>' + '</div>',
    link: function link($scope, $el, $attrs, layoutCtrl) {
      $scope.togglePanel = function () {
        layoutCtrl.togglePanel();
      };
    }
  };
});

/**
 * The right side ( content ) of the layout
 */
ngModule.directive("tlPanelRight", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    transclude: true,
    template: '<div class="tl-panel-right autosize-reference" ng-transclude></div>'
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/structure/tlPanelLayout.js
// module id = 3006
// module chunks = 13